import React from "react";
import { ScrollingText } from "@common/scrollingText";
import { Props } from "./types";

function TruncatedName({ name, className }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [title, setTitle] = React.useState<string | undefined>(undefined);

  const updateTitle = () => {
    const container = ref.current?.firstElementChild;

    setTitle(
      container && container.scrollWidth > container.clientWidth
        ? name
        : undefined,
    );
  };

  return (
    <div ref={ref} title={title} onMouseEnter={updateTitle}>
      <ScrollingText speed={100}>
        <p className={className}>{name}</p>
      </ScrollingText>
    </div>
  );
}

export { TruncatedName };
